import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogTarefaEtiquetaComponent } from '@app/components/dialog-tarefa-etiqueta/dialog-tarefa-etiqueta.component';
import { ListaDadosColuna } from '@app/components/lista-dados/lista-dados.component';
import { BeTarefaEtiqueta } from '@app/models/be-tarefa';
import { SnackBarService } from '@app/services/snack-bar.service';

export interface DialogTarefasEtiquetasData {
  etiquetas: BeTarefaEtiqueta[];
}

@Component({
  selector: 'app-dialog-tarefas-etiquetas',
  templateUrl: './dialog-tarefas-etiquetas.component.html',
  styleUrls: ['./dialog-tarefas-etiquetas.component.css']
})
export class DialogTarefasEtiquetasComponent {
  public etiquetas: BeTarefaEtiqueta[];
  public alterado = false;
  public readonly colunas: ListaDadosColuna[] = [{
    campo: 'noEtiqueta', rotulo: 'Etiqueta', tamanho: '100%', tipoExibicao: 'etiqueta',
    corValor: etiqueta => etiqueta.noCor,
    corTextoValor: etiqueta => this.corTexto(etiqueta.noCor)
  }];

  public constructor(
    @Inject(MAT_DIALOG_DATA) data: DialogTarefasEtiquetasData,
    private readonly dialog: MatDialog,
    private readonly dialogRef: MatDialogRef<DialogTarefasEtiquetasComponent>,
    private readonly http: HttpClient,
    private readonly snackBarService: SnackBarService
  ) {
    this.etiquetas = data.etiquetas.map(etiqueta => ({ ...etiqueta }));
  }

  public abrirEtiqueta(etiqueta?: BeTarefaEtiqueta): void {
    this.dialog.open(DialogTarefaEtiquetaComponent, {
      autoFocus: true,
      disableClose: true,
      width: '460px',
      maxWidth: 'calc(100vw - 32px)',
      data: { etiqueta: etiqueta ? { ...etiqueta } : undefined }
    }).afterClosed().subscribe(resultado => {
      if (!resultado) return;
      const requisicao = resultado.id
        ? this.http.put<BeTarefaEtiqueta>(`/api/Tarefas/etiquetas/${resultado.id}`, resultado)
        : this.http.post<BeTarefaEtiqueta>('/api/Tarefas/etiquetas', resultado);
      requisicao.subscribe({
        next: etiquetaSalva => {
          const indice = this.etiquetas.findIndex(item => item.id === etiquetaSalva.id);
          this.etiquetas = indice >= 0
            ? this.etiquetas.map(item => item.id === etiquetaSalva.id ? etiquetaSalva : item)
            : [...this.etiquetas, etiquetaSalva];
          this.alterado = true;
          this.snackBarService.exibirSucesso(resultado.id ? 'Etiqueta atualizada.' : 'Etiqueta criada.');
        },
        error: erro => this.snackBarService.exibirErro(erro?.error?.mensagem ?? 'Não foi possível salvar a etiqueta.')
      });
    });
  }

  public removerEtiqueta(etiqueta: BeTarefaEtiqueta): void {
    if (!etiqueta.id) return;
    this.http.delete(`/api/Tarefas/etiquetas/${etiqueta.id}`).subscribe({
      next: () => {
        this.etiquetas = this.etiquetas.filter(item => item.id !== etiqueta.id);
        this.alterado = true;
        this.snackBarService.exibirSucesso('Etiqueta removida.');
      },
      error: erro => this.snackBarService.exibirErro(erro?.error?.mensagem ?? 'Não foi possível remover a etiqueta.')
    });
  }

  public fechar(): void {
    this.dialogRef.close(this.alterado);
  }

  private corTexto(cor: string): string {
    const hexadecimal = cor.replace('#', '');
    const vermelho = parseInt(hexadecimal.substring(0, 2), 16);
    const verde = parseInt(hexadecimal.substring(2, 4), 16);
    const azul = parseInt(hexadecimal.substring(4, 6), 16);
    return (vermelho * 299 + verde * 587 + azul * 114) / 1000 < 150 ? '#fff' : '#1f2933';
  }
}
